(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-cta"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('sticky-cta')) {
    class StickyCta extends HTMLElement {
      connectedCallback() {
        this.closeButton = this.querySelector('[data-sticky-cta-close]');
        this.appearance = this.dataset.appearance;
        this.onScroll = this.updateVisibility.bind(this);

        this.closeButton?.addEventListener('click', () => {
          this.dismissed = true;
          this.hide();
        });

        if (this.appearance === 'always') {
          this.show();
          return;
        }

        if (this.appearance === 'delay') {
          this.delayTimer = window.setTimeout(
            () => this.show(),
            Number(this.dataset.delaySeconds || 0) * 1000
          );
          return;
        }

        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.updateVisibility();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.clearTimeout(this.delayTimer);
      }

      updateVisibility() {
        if (this.dismissed) return;

        let shouldShow = false;

        if (this.appearance === 'scroll_pixels') {
          shouldShow = window.scrollY >= Number(this.dataset.scrollPixels || 0);
        }

        if (this.appearance === 'scroll_percent') {
          const scrollableHeight = document.documentElement.scrollHeight - window.innerHeight;
          const scrollPercent = scrollableHeight > 0 ? (window.scrollY / scrollableHeight) * 100 : 0;
          shouldShow = scrollPercent >= Number(this.dataset.scrollPercent || 0);
        }

        shouldShow ? this.show() : this.hide();
      }

      show() {
        if (this.dismissed) return;
        this.classList.add('is-visible');
        this.setAttribute('aria-hidden', 'false');
      }

      hide() {
        this.classList.remove('is-visible');
        this.setAttribute('aria-hidden', 'true');
      }
    }

    customElements.define('sticky-cta', StickyCta);
  }

  } catch(e) { console.error(e); }
})();
})();
